import _toConsumableArray from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import { uploadExcelFile as _uploadExcelFile, uploadFile, createPrintShow } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    //  上传图片列表
    _this.fileList = [];
    // 打印内容图片id
    _this.imgids = '';
    //  是否已经上传最大数量图片
    _this.maxpic = false;
    _this.excel = '';
    _this.excelId = '';
    _this.mobile = '';
    _this.remark = '';
    _this.loading = false;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {}
    // 上传excel
  }, {
    key: "uploadExcelFile",
    value: function () {
      var _uploadExcelFile2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        var file, form, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              file = event.target.files[0];
              form = new FormData();
              form.append('fileData', file);
              form.append('type', '11');
              _context.next = 7;
              return _uploadExcelFile(form);
            case 7:
              res = _context.sent;
              this.excel = res.data.data[0].sourceName;
              this.excelId = res.data.data[0].id;
              // eslint-disable-next-line no-param-reassign
              event.target.value = '';
              this.loading = false;
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function uploadExcelFile(_x) {
        return _uploadExcelFile2.apply(this, arguments);
      }
      return uploadExcelFile;
    }() // 上传图片
  }, {
    key: "uploadpic",
    value: function () {
      var _uploadpic = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var file, uploadlength, form, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.loading = true;
              file = _toConsumableArray(event.target.files);
              if (!(this.fileList.length < 5)) {
                _context2.next = 10;
                break;
              }
              uploadlength = 5 - this.fileList.length;
              form = new FormData();
              file.forEach(function (value) {
                form.append('fileData', value);
                form.append('type', '11');
              });
              _context2.next = 8;
              return uploadFile(form);
            case 8:
              res = _context2.sent;
              if (res.data.code === 100) {
                this.fileList = [].concat(_toConsumableArray(this.fileList), _toConsumableArray(res.data.data.slice(0, uploadlength)));
                if (this.fileList.length === 5) {
                  this.maxpic = true;
                }
                this.imgids = this.fileList.map(function (e) {
                  return e.id;
                }).join(',');
              } else {
                this.$message.error(res.data.message);
              }
            case 10:
              // eslint-disable-next-line no-param-reassign
              event.target.value = '';
              this.loading = false;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function uploadpic(_x2) {
        return _uploadpic.apply(this, arguments);
      }
      return uploadpic;
    }()
  }, {
    key: "removefile",
    value: function removefile(index) {
      this.fileList.splice(index, 1);
      this.maxpic = false;
    }
  }, {
    key: "delexcel",
    value: function delexcel() {
      this.excel = '';
      this.excelId = '';
    }
  }, {
    key: "next",
    value: function () {
      var _next = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this$$route$query, productId, materialName;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this$$route$query = this.$route.query, productId = _this$$route$query.productId, materialName = _this$$route$query.materialName;
              if (this.mobile === '') {
                this.$message.error('请填写联系方式');
              } else {
                createPrintShow({
                  productId: productId,
                  mobile: this.mobile,
                  materialName: materialName,
                  size: this.$route.query.size,
                  orderNum: this.$route.query.orderNum,
                  customizContent: this.imgids,
                  excelId: this.excelId,
                  remark: this.remark,
                  companyId: 1
                });
                this.$router.push('/erial-success');
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function next() {
        return _next.apply(this, arguments);
      }
      return next;
    }()
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    BackTop: BackTop
  }
})], default_1);
export default default_1;